module.exports = __webpack_public_path__ + "23_cikm_2.jpg?92055112e1c7e900685a9aa9a101d619";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_cikm_2.jpg
// module id = 197
// module chunks = 0